import React from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { useMobileMenu } from "../hooks/useMobileMenu";
import StoreBanner from "./store-banner";
import danceLocaleIcon from "../assets/dance_locale_3-200h.png";
import "../pages/header.css";

/**
 * AppHeader — shared navigation header used across all authenticated pages.
 *
 * @param {string} activeItem - Which nav item to highlight: 'home' | 'dashboard' | 'help'
 */
const AppHeader = ({ activeItem }) => {
    const { logout, user } = useAuth();
    const navigate = useNavigate();
    useMobileMenu();

    const handleLogout = () => {
        logout();
        navigate("/");
    };

    const navClass = (item) =>
        `home-text12${activeItem === item ? " home-nav-active" : ""}`;

    const helpPath = user?.organisationId ? "/help" : "/my-hub/help";

    return (
        <div data-role="Header" className="home-header-container">
            <header className="home-header">
                <a href="/" className="home-logo1">
                    <img alt="logo" src={danceLocaleIcon} className="home-image1" />
                    <span className="nav-wordmark">Dance Localé</span>
                </a>
                <div className="home-menu1">
                    <a href="/" className={`home-text10${activeItem === "home" ? " home-nav-active" : ""}`}>
                        Home
                    </a>
                    {user?.organisationId && (
                        <a href="/dashboard" className={navClass("dashboard")}>
                            Dashboard
                        </a>
                    )}
                    {user && (
                        <a href="/my-hub" className={navClass("my-hub")}>
                            My Hub
                        </a>
                    )}
                    <a href={helpPath} className={navClass("help")}>
                        Help
                    </a>
                    <button className="home-text12" onClick={handleLogout}>
                        Logout
                    </button>
                    {user?.loginType === 'orgContext' && user?.role && (
                        <span className="app-header-role-indicator">
                            {user.accountDetails?.firstName || user.username || user.email}
                            <span className={`settings-role-badge settings-role-badge--${user.role}`}>
                                {user.role.charAt(0).toUpperCase() + user.role.slice(1)}
                            </span>
                        </span>
                    )}
                </div>
                <div className="home-container11">
                    <StoreBanner />
                </div>
                <div data-role="BurgerMenu" className="home-burger-menu">
                    <svg viewBox="0 0 1024 1024" className="home-menu2">
                        <path d="M810.667 725.333h-597.333c-47.061 0-85.333 38.272-85.333 85.333s38.272 85.333 85.333 85.333h597.333c47.061 0 85.333-38.272 85.333-85.333s-38.272-85.333-85.333-85.333z"></path>
                        <path d="M810.667 426.667h-597.333c-47.061 0-85.333 38.272-85.333 85.333s38.272 85.333 85.333 85.333h597.333c47.061 0 85.333-38.272 85.333-85.333s-38.272-85.333-85.333-85.333z"></path>
                        <path d="M810.667 128h-597.333c-47.061 0-85.333 38.272-85.333 85.333s38.272 85.333 85.333 85.333h597.333c47.061 0 85.333-38.272 85.333-85.333s-38.272-85.333-85.333-85.333z"></path>
                    </svg>
                </div>
            </header>
            <div data-role="MobileMenu" className="home-mobile-menu">
                <div className="home-top">
                    <div className="home-logo2">
                        <img alt="logo" src={danceLocaleIcon} className="home-image2" />
                    </div>
                    <div data-role="CloseMobileMenu" className="home-close-menu">
                        <svg viewBox="0 0 1024 1024" className="home-icon15">
                            <path d="M810 274l-238 238 238 238-60 60-238-238-238 238-60-60 238-238-238-238 60-60 238 238 238-238z"></path>
                        </svg>
                    </div>
                </div>
                <div className="home-mid">
                    <span className="home-text14" onClick={() => navigate("/")}>
                        Home
                    </span>
                    {user?.organisationId && (
                        <span className="home-text16" onClick={() => navigate("/dashboard")}>
                            Dashboard
                        </span>
                    )}
                    {user && (
                        <span className="home-text16" onClick={() => navigate("/my-hub")}>
                            My Hub
                        </span>
                    )}
                    <span className="home-text16" onClick={() => navigate(helpPath)}>
                        Help
                    </span>
                    <span className="home-text17" onClick={handleLogout}>
                        Logout
                    </span>
                </div>
            </div>
        </div>
    );
};

export default AppHeader;
